import { render, staticRenderFns } from "./DictionaryCourses.vue?vue&type=template&id=456ec0d5&"
import script from "./DictionaryCourses.vue?vue&type=script&lang=js&"
export * from "./DictionaryCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports